var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main container" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-12 text-center" }, [
        _c("h4", { staticClass: "highlight-color" }, [
          _vm._v(_vm._s(_vm.$t("message.title_choosestore")))
        ])
      ]),
      _vm._v(" "),
      _vm.$store.state.app.loading && _vm.shops.length == 0
        ? _c("p", { staticClass: "text-center mt-4" }, [_vm._v("Loading...")])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.shops, function(item, index) {
        return _c("div", { staticClass: "col-md-6 form no-padding" }, [
          _c("div", { staticClass: "col-md-12 text-center header" }, [
            _c("strong", [_vm._v(_vm._s(item.shop_name))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-12 content" }, [
            !_vm.$store.state.app.loading
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-web btn-block",
                    attrs: { type: "submit" },
                    on: {
                      click: function($event) {
                        return _vm.loginShop(item.shop_id)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("message.loginshop")) +
                        "\n      "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.state.app.loading
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-web btn-block disabled",
                    attrs: { type: "submit" }
                  },
                  [_c("i", { staticClass: "fas fa-spinner spin" })]
                )
              : _vm._e()
          ])
        ])
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo col-md-12 text-center" }, [
      _c("img", { attrs: { src: require("./../../assets/logo-10.png") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0989c502", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0989c502","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/ChooseShop.vue
// module id = null
// module chunks = 